import { Component, HostListener, inject } from '@angular/core';
import { AllInputTypes, FormInputConfig } from '../../../../../../trash/shared/interfaces/form-input-config';
import { Validators } from '@angular/forms';
import { FormComponent } from '../../../../../../trash/shared/components/dynamic-form/form/form.component';
import { NgIf } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LiveTranslateService } from '../../../../../../trash/shared/services/live-translate.service';
import { Router, RouterModule } from '@angular/router';
import { LoaderService } from '../../../../../../trash/shared/components/loader/loader.service';
import { Logger } from '../../../../../core/utilities/logging/logger';
import { AuthenticationService } from '../../services/authentication.service';
import { UserContextService } from '../../services/user-context.service';
import { UserUiService } from '../../../../../../shared';
import { SwitchLanguageComponent } from '../../../../../../trash/shared/components/switch-language/switch-language.component';

interface ILoginFormData {
  loginInput: string;
  password: string;
  keepMeLoggedIn: boolean;
}

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [TranslateModule, FormComponent, NgIf, HttpClientModule, RouterModule, SwitchLanguageComponent],
  providers: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  authService = inject(AuthenticationService);
  router = inject(Router);
  liveTranslate = inject(LiveTranslateService);
  loaderService = inject(LoaderService);
  translate = inject(TranslateService);
  userUiService = inject(UserUiService);

  formValues: ILoginFormData | undefined;
  form: FormInputConfig[] = [];
  validationEmit: boolean = false;
  validationErrors: any = {};

  ngOnInit(): void {
    if (UserContextService.isAuthenticated()) {
      this.router.navigate([this.userUiService.getInitialPage()]);
      return;
    }
    this.initForm();
  }

  private initForm(): void {
    this.form = [
      {
        type: AllInputTypes.Text,
        name: 'loginInput',
        label: this.translate.instant('FORMS.EMAIL'),
        placeholder: `${this.translate.instant('GENERAL.ENTER')} ${this.translate.instant('FORMS.EMAIL')}`,
        widthClass: 'col-md-12',
        defaultValue: this.formValues?.loginInput,
        validation: [
          {
            function: Validators.required,
            errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.EMAIL')}`
          },
          {
            function: Validators.email,
            errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.VALID_EMAIL')}`
          }
        ]
      },
      {
        type: AllInputTypes.Password,
        name: 'password',
        label: this.translate.instant('FORMS.PASSWORD'),
        placeholder: `${this.translate.instant('GENERAL.ENTER')} ${this.translate.instant('FORMS.PASSWORD')}`,
        widthClass: 'col-md-12',
        defaultValue: this.formValues?.password,
        validation: [
          {
            function: Validators.required,
            errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.PASSWORD')}`
          }
        ]
      },
      {
        type: AllInputTypes.CheckBox,
        name: 'keepMeLoggedIn',
        label: this.translate.instant('GENERAL.REMEMBER_ME'),
        widthClass: 'col-md-12 loginCheck',
        defaultValue: this.formValues?.keepMeLoggedIn || false,
        validation: []
      }
    ];
  }

  async submitForm(loginFormData: ILoginFormData) {
    Logger.debug('this.form', this.form);
    this.loaderService.show();
    this.authService.authenticate(loginFormData, loginFormData.keepMeLoggedIn);
    this.loaderService.hide();
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Enter' && this.formValues?.loginInput && this.formValues?.password) {
      this.submitForm(this.formValues);
    }
  }

  getDecodedAccessToken(token: string): any {}

  valueChanged(data: any) {
    Logger.debug(data);
    this.formValues = {
      ...data
    };
  }

  login(): void {
    this.validationEmit = !this.validationEmit;
  }
}
